@if (status?.visible()) {
  <div class="atgard-header-icon">
    @for (icon of status.icons; track $index) {
      <span
        [ngClass]="{'incomplete': icon.incomplete, 'warning': icon.warning }">
        @if (icon.visible) {
          <rask-icon-stacked [icon]="icon.iconclass1" [icon2]="icon.iconclass2"
            [customTriggers]="icon.customTriggers"
            popoverClass="atgard-header-icon-popover">
            <div class="popover-header">
              <h4 class="header-text">{{ status.header }}</h4>
            </div>
            <div>
              @for (tooltip of status.tooltips; track $index) {
                <div class="d-flex" class="atgard-header-tooltip">
                  @if (tooltip.visible && !(tooltip.hideWhenDirty && isDirty)) {
                    <rask-textmultiline
                      [label]="tooltip.header"
                      [wrapLabel]="true"
                      [iconClass]="tooltip.iconClass"
                      [ultraTightLabel]="true"
                      [boldText]="tooltip.bold">
                      @if(tooltip.link?.onClick && !tooltip.link?.route){
                        <a class="route-text"
                          (click)="clickTooltip(tooltip, $event)">
                          {{tooltip.routeText}}
                        </a>
                      }
                      @else if (tooltip.link?.route) {
                      <a class="route-text" [target]="tooltip.link.target"
                        [routerLink]="tooltip.link.route"
                        [queryParams]="tooltip.link.queryParams">
                        {{tooltip.routeText}} @if (tooltip.link.target === '_blank') {
                        <i
                        class="fa-regular fa-up-right-from-square"></i>
                      }
                    </a>
                  }
                  @else {
                  {{tooltip.routeText}}
                }
                <span>{{tooltip.text}}</span>
              </rask-textmultiline>
            }
          </div>
        }
      </div>
    </rask-icon-stacked>
  }
</span>
}
</div>
}